/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Region,
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './';

/**
 * 
 * @export
 * @interface RegionListBusinessDataResponse
 */
export interface RegionListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof RegionListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<Region>}
     * @memberof RegionListBusinessDataResponse
     */
    businessData?: Array<Region> | null;
    /**
     * 
     * @type {number}
     * @memberof RegionListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof RegionListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof RegionListBusinessDataResponse
     */
    totalRecords?: number;
}

export function RegionListBusinessDataResponseFromJSON(json: any): RegionListBusinessDataResponse {
    return RegionListBusinessDataResponseFromJSONTyped(json, false);
}

export function RegionListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegionListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(RegionFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function RegionListBusinessDataResponseToJSON(value?: RegionListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(RegionToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


